var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "filterModal", attrs: { id: "filter-modal" } }, [
    _c(
      "div",
      {
        staticClass: "filters-content",
        on: {
          click: function ($event) {
            return _vm.toggle()
          },
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.hasSlot("content") && _vm.isActive
      ? _c(
          "div",
          {
            ref: "filterDropdown",
            staticClass: "filters-dropdown",
            class: [_vm.align],
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "filter-dropdown-content" }, [
              _c("div", { staticClass: "filter-input-group" }, [
                _c("div", { staticClass: "title" }, [_vm._v("Filter Name")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "body" },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "filter-dropdown-footer",
                class: { large: !!_vm.value },
              },
              [
                _vm.value
                  ? _c(
                      "div",
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "", small: "" },
                            on: { click: _vm.deleteAction },
                          },
                          [_c("a-icon", { attrs: { type: "delete" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "", small: "" },
                        on: {
                          click: function ($event) {
                            _vm.isActive = false
                          },
                        },
                      },
                      [_vm._v(" Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "", small: "" },
                        on: { click: _vm.saveAction },
                      },
                      [_vm._v(" Save")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-dropdown-head" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Save search as favorite")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }